import './index.scss'
$("#nav8").addClass("active");
$(function () {
    $(window).scroll(function () {
        // 可是窗口滚动条发生滚动的时候 垂直方向滚动到多少距离的时候 让头部导航条设置上一个固定定位的样式
        if ($(window).scrollTop() >= ($("header").height())) {
            // alert($("#slideBox").height());
            $("header").addClass("head1");
        } else {
            $("header").removeClass("head1");
        }
    })
})

// 鼠标进入地图时禁用地图滚动
$('#container').mouseenter(function() {
    if (window.map1) {
        map1.setStatus({scrollWheel: false});
        map1.setStatus({zoomEnable: false});
    }
});